import React from 'react';
import {useIntl} from 'react-intl';

import {useLocalStorage} from 'coreHooks';

import CheckboxField from 'brandComponents/Form/Subcomponents/CheckboxField';

import messages from './messages';

import styles from './AuthLoginFormRememberMe.module.scss';

const AuthLoginFormRememberMe = () => {
	const intl = useIntl();
	const [localStorageChecked] = useLocalStorage<boolean>('login-flyout_remember-me', false);

	return (
		<CheckboxField
			name="rememberMe"
			initialValue={!!localStorageChecked}
			label={intl.formatMessage(messages.remember)}
			classNamesCntr={styles['auth__login-form__remember-me']}
		/>
	);
};

export default AuthLoginFormRememberMe;
